import { render } from "./ItemsView.vue?vue&type=template&id=4b4d388d&ts=true"
import script from "./ItemsView.vue?vue&type=script&lang=ts"
export * from "./ItemsView.vue?vue&type=script&lang=ts"

import "./ItemsView.vue?vue&type=style&index=0&id=4b4d388d&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__